module.exports = __webpack_public_path__ + "static/media/start-from-here.8d5cb30a.png";